import LegalRepresentative from './LegalRepresentative'

export default class LegalRepresentativeExtended extends LegalRepresentative {
  disabled: boolean
}
